export default "__VITE_ASSET__DkfKO8Zc__"